const fileGroups = {
  sailor: {
    idv: "ID&V",
    sailorRiskProfile: "Sailor Risk Profile",
    supportingDocumentation: "Supporting Documentation",
  },
  dealer: {
    dealerRiskProfile: "Dealer Risk Profile",
  },
  application: {
    billsOfSale: "Bills Of Sale",
    buildersCertification: "Builders Certification",
    creditUnderwriting: "Credit Underwriting",
    insurance: "Insurance",
    invoices: "Invoices",
    loanDocs: "Loan Docs",
    mcaRegistrationCertificate: "MCA Registration Certificate",
    otherBoatDocs: "Other Boat Docs",
    survey: "Survey",
    vatDocument: "VAT Document",
  },
  agreement: {
    arrearsMgmt: "Arrears Management",
  },
};

const fileGroupPurposeMap = {
  idv: {
    front: "Front",
    back: "Back",
    selfie: "Selfie",
  },
  supportingDocumentation: {
    "3monthBankStatements": "3 Month Bank Statements",
    proofOfIncome: "Proof Of Income",
    accounts: "Accounts",
    missing: "Missing Docs",
  },
  sailorRiskProfile: {
    idvFile: "ID&V File",
    kycAmlFile: "KYC/AML File",
  },
  dealerRiskProfile: {
    kybFile: "KYB File",
  },
};

const getFilePurposeParts = (fileGroup) => {
  if (!(fileGroup in fileGroupPurposeMap)) {
    return {
      hasFilePurposes: false,
    };
  }
  const filePurposes = fileGroupPurposeMap[fileGroup];
  return {
    getDropdownValues: () =>
      Object.entries(filePurposes).map(([value, label]) => ({
        value,
        label,
      })),
    getLabel: (filePurpose) => filePurposes[filePurpose],
    filePurposes,
    hasFilePurposes: true,
  };
};

export const generateFileResolver = (fileCategory, fileGroup) => {
  const parts = getFilePurposeParts(fileGroup);
  return {
    ...parts,
    fileCategory,
    fileGroup,
    fileGroupLabel: fileGroups[fileCategory][fileGroup],
  };
};

const initalizeFileResolvers = () =>
  Object.entries(fileGroups).reduce(
    (previous, [fileCategoryKey, fileGroupObject]) => {
      const resolvers = Object.entries(fileGroupObject).reduce(
        (innerPrev, [fileGroupKey]) => {
          return {
            ...innerPrev,
            [fileGroupKey]: generateFileResolver(fileCategoryKey, fileGroupKey),
          };
        },
        {}
      );
      return {
        ...previous,
        ...resolvers,
      };
    },
    {}
  );

const fileDisplay = {
  sailor: {
    supportingDocumentation: "Supporting Documentation",
  },
  boat: {
    buildersCertification: "Builders Certification",
    billsOfSale: "Bills Of Sale",
    mcaRegistrationCertificate: "MCA Registration Certificate",
    vatDocument: "VAT Document",
    otherBoatDocs: "Other Boat Docs",
  },
};

const fileResolvers = initalizeFileResolvers();

const getFileResolver = (fileGroup) => {
  if (!(fileGroup in fileResolvers)) {
    throw new Error(`File Resolver for ${fileGroup} doesn't exist`);
  }
  return fileResolvers[fileGroup];
};

const fileConfig = {
  fileGroups,
  fileResolvers,
  fileDisplay,
  getFileResolver,
};

export default fileConfig;
